/**
 * Orchestration Intent Detector
 *
 * Detects orchestration-related intent in chatbot messages when the user
 * is on the Orchestration page. When detected, the chatbot routes the
 * message through the AI generation pipeline instead of the regular chat flow.
 *
 * Requirements: 11.1, 11.5 (orchestration-ai-generation)
 */

/**
 * Keywords/phrases that indicate orchestration management intent.
 * These are checked as substrings of the lowercased message.
 */
const ORCHESTRATION_KEYWORDS = [
  'add step',
  'create orchestration',
  'organize flow',
  'wire variable',
  'pass token',
  'chain',
  'add api',
  'edit step',
  'modify script',
  'reorder',
  'add steps',
  'organize orchestration',
  'set up flow',
  'configure step',
  'pass variable',
  'wire data',
  'data chain',
  'variable chaining',
  'add header',
  'set script',
  'post script',
  'pre script',
  'move step',
];

/**
 * Detect whether a chatbot message contains orchestration management intent.
 *
 * Only triggers when the user is currently on the Orchestration page.
 * Returns true if the message matches known orchestration keywords/phrases.
 *
 * @param {string} message - The user's chat message
 * @param {string} currentPage - The detected page identifier from useChatContext (e.g., "Orchestration")
 * @returns {boolean} True if orchestration intent is detected
 */
export function detectOrchestrationIntent(message, currentPage) {
  if (currentPage !== 'Orchestration') return false;
  if (!message || !message.trim()) return false;

  const msgLower = message.toLowerCase();
  return ORCHESTRATION_KEYWORDS.some((kw) => msgLower.includes(kw));
}

export default detectOrchestrationIntent;
